import React, { useCallback, useMemo, useState } from 'react'
import axios from 'lib/axios'
import Select from 'components/QuestionnaireRequest/AdminNew/components/Select'
import ToggleCheckbox from 'components/QuestionnaireRequest/AdminNew/components/checkbox'

const QUESTIONNAIRE_TYPE_LABELS = {
  inherit: 'same as org',
  manual: 'manual only',
  auto: 'both manual and auto',
}

const toQuestionnaireTypeOptions = (organizationQuestionnaireType) => [
  {
    value: null,
    label: `${QUESTIONNAIRE_TYPE_LABELS['inherit']} - ${QUESTIONNAIRE_TYPE_LABELS[organizationQuestionnaireType]}`,
  },
  { value: 'manual', label: QUESTIONNAIRE_TYPE_LABELS['manual'] },
  { value: 'auto', label: QUESTIONNAIRE_TYPE_LABELS['auto'] },
]

const QuestionnaireType = ({
  buildingId,
  questionnaireType,
  updateQuestionnaireType,
  updating,
  setUpdating,
  organizationQuestionnaireType,
}) => {
  const onClose = useCallback(
    async (selectedItem) => {
      setUpdating(true)
      const url = `/buildings/${buildingId}/questionnaires/update_questionnaire_type`
      await axios.post(url, {
        questionnaire_type: selectedItem,
      })
      setUpdating(false)
      updateQuestionnaireType(selectedItem)
    },
    [updateQuestionnaireType, setUpdating]
  )

  const questionnaireTypeOptions = useMemo(() => {
    if (organizationQuestionnaireType === 'auto') {
      return toQuestionnaireTypeOptions(organizationQuestionnaireType)
    }

    return toQuestionnaireTypeOptions(organizationQuestionnaireType).filter((option) => option.value !== 'auto')
  }, [organizationQuestionnaireType])

  const selectedQuestionnaireType = useMemo(() => {
    if (organizationQuestionnaireType === 'auto') return questionnaireType

    return questionnaireType === 'auto' ? null : questionnaireType
  }, [organizationQuestionnaireType, questionnaireType])

  return (
    <Select
      multiple={false}
      onClose={onClose}
      options={questionnaireTypeOptions}
      defaultSelectedItem={selectedQuestionnaireType}
      disabled={organizationQuestionnaireType !== 'auto' || updating}
      atLeastOne={true}
    />
  )
}

const EnableCheckbox = ({ buildingId, enabled, updateEnabled, updating, setUpdating }) => {
  const changeValue = async (enabled) => {
    try {
      setUpdating(true)
      const url = `/buildings/${buildingId}/questionnaires/enable`
      await axios.post(url, { enable: enabled ? 1 : 0 })
      updateEnabled(enabled)
    } catch (error) {
      console.log(error)
    } finally {
      setUpdating(false)
    }
  }

  return (
    <div className="dome-d-flex dome-align-start">
      <ToggleCheckbox
        label="enable questionnaires"
        defaultChecked={enabled}
        disabled={updating}
        onChange={(e) => changeValue(e.target.checked)}
      />
    </div>
  )
}

export default function EnableQuestionnaire({
  buildingId,
  enabled,
  updateEnabled,
  questionnaireType,
  updateQuestionnaireType,
  organizationQuestionnaireType,
}) {
  const [updating, setUpdating] = useState(false)

  return (
    <div className="questionnaire-admin-general-row">
      <EnableCheckbox
        buildingId={buildingId}
        enabled={enabled}
        updateEnabled={updateEnabled}
        updating={updating}
        setUpdating={setUpdating}
      />
      {enabled && (
        <QuestionnaireType
          buildingId={buildingId}
          questionnaireType={questionnaireType}
          updateQuestionnaireType={updateQuestionnaireType}
          updating={updating}
          setUpdating={setUpdating}
          organizationQuestionnaireType={organizationQuestionnaireType}
        />
      )}
    </div>
  )
}
